function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAiSuggestionShineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.565 4.005V6H5.038c-.497 0-.709.16-.814.286-.131.156-.224.415-.224.752V21c0 .159.093.406.336.638.242.232.514.334.702.334h8.328l.168.014c.165.028.32.098.453.203l6.125 4.855v-4.072a1 1 0 011-1h3.926c.34 0 .59-.091.737-.213.116-.097.266-.292.266-.76v-3.46h2V21c0 .975-.351 1.768-.986 2.297-.605.503-1.357.676-2.017.676h-2.926v5.14a1.001 1.001 0 01-1.62.784l-7.474-5.924h-7.98c-.812 0-1.558-.384-2.085-.888C2.427 22.58 2 21.84 2 21V7.038c0-.663.177-1.423.69-2.036C3.23 4.359 4.036 4 5.038 4h9.527v.005z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.13 2.342c.078-.456.738-.456.816 0a8.295 8.295 0 006.605 6.721l.073.43.071-.402c.457.078.457.739 0 .817a8.297 8.297 0 00-6.749 6.749c-.078.456-.738.456-.816 0a8.297 8.297 0 00-6.75-6.75c-.427-.072-.454-.657-.08-.794l.08-.022a8.297 8.297 0 006.75-6.749zm.408 4.263A10.31 10.31 0 0119.644 9.5a10.311 10.311 0 012.894 2.893A10.31 10.31 0 0125.432 9.5a10.311 10.311 0 01-2.894-2.895zm7.157 2.486l-.071.403-.073-.43.144.027z",
    fill: props.color
  }));
}

export default SvgIconAiSuggestionShineFilled;